'use client';
import AddToCart from '@/components/molecules/AddToCart';
import useProduct from '@/contexts/ProductProvider';

const WrapperAddToCart = () => {
	const { selectedVariant, product } = useProduct();

	return (
		<div className='d-flex justify-flex-end items-center gap-20'>
			<AddToCart
				product={product}
				height='48px'
				variant={selectedVariant}
				productRawData={product}
				inputStyle={{}}
				style={{
					height: 48
				}}
				outOfStockClass='p-20 fw-700'
				label={
					<>
						<span className='p-20'>Add to Cart</span>
					</>
				}
			/>
		</div>
	);
};

export default WrapperAddToCart;
